import { Slider, styled } from "@mui/material";

const RentPercSlider = (props) => {
  const { effortRatePecentage, changeEffortRatePercentage, value } = props;

  const RentSlider = styled(Slider)({
    color: "#A3EB64",
    // height: 8,
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-root": { margin: 0 },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "7px solid #253837",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&::before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      //   display: "none",
      lineHeight: 1.2,
      fontSize: 9,
      background: "unset",
      padding: 0,
      width: 38,
      height: 38,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "#52af77",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&::before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  });
  const marks = [
    {
      value: 1,
      label: "1%",
    },
    {
      value: 100,
      label: "100%",
    },
  ];

  return (
    <>
      <RentSlider
        className="rent-slider"
        defaultValue={effortRatePecentage}
        aria-label="Default"
        onChangeCommitted={changeEffortRatePercentage}
        valueLabelDisplay="on"
        valueLabelFormat={(value) => `${value}%`}
        marks={marks}
        min={1}
        max={100}
      />
    </>
  );
};

export default RentPercSlider;
